export enum Key {
  ANDROID_WEBVIEW_PARAMS_KEY = 'hgSourceParameter', // This key is used to store parameters for the Android WebView
}

export interface AndroidWebViewParams {
  source?: string;
  tenantPlusCh?: string;
}

export const getAndroidWebViewParamsFromStorage = (): AndroidWebViewParams => {
  const paramsJson = sessionStorage.getItem(Key.ANDROID_WEBVIEW_PARAMS_KEY);
  try {
    return paramsJson ? JSON.parse(paramsJson) : {};
  } catch {
    return {};
  }
};

export const initializeAndroidWebViewParamsInStorage = (params: AndroidWebViewParams): void => {
  // Do not overwrite existing params if they are already stored
  if (sessionStorage.getItem(Key.ANDROID_WEBVIEW_PARAMS_KEY) !== null) {
    return;
  }

  sessionStorage.setItem(Key.ANDROID_WEBVIEW_PARAMS_KEY, JSON.stringify(params));
};

export const setAndroidWebViewParamsInStorage = (source?: string, tenantPlusCh?: string): void => {
  const params: AndroidWebViewParams = {
    source: source ?? undefined,
    tenantPlusCh: tenantPlusCh ?? undefined,
  };

  initializeAndroidWebViewParamsInStorage(params);
};
